import PropTypes from 'prop-types';
import React from 'react';
import ContentLoader from 'react-content-loader';

import { StyledSkeletonLoader } from './styles';

const SkeletonLoader = ({ className }) => {
  return (
    <StyledSkeletonLoader className={className}>
      <ContentLoader height="100%" width="100%">
        <circle cx="50%" cy="50%" r="50%" />
      </ContentLoader>
    </StyledSkeletonLoader>
  );
};

SkeletonLoader.propTypes = {
  className: PropTypes.string,
};

SkeletonLoader.defaultProps = {
  className: undefined,
};

export default SkeletonLoader;
